export const SHIPPING_METHODS = {
  SEND_LABEL: 'SEND_LABEL',
  SELF_SHIP: 'SELF_SHIP',
  STORE_RETURN: 'STORE_RETURN'
};
